import React from "react";
import { useTranslation } from "react-i18next";

import { BatAnim } from "../../animations/Animations";
import { StyledErrorPage } from "../notFound/NotFound.styles";

interface IProps {
    inline?: boolean;
}

export const ErrorPage: React.FunctionComponent<IProps> = React.memo((props) => {
    const { t, i18n } = useTranslation("Common");
    const key = "Common:Errors.CommunicationWithServerFailed";
    const message = i18n.exists(key) ? t(key) : "Selhala komunikace se serverem. Kontaktujte, prosím, podporu.";
    return (
            <StyledErrorPage $inline={props.inline}>
                <BatAnim/>
                <h2>{message}</h2>
            </StyledErrorPage>
    );
});
